import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=20bdf2bd&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bdf2bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20bdf2bd')) {
      api.createRecord('20bdf2bd', component.options)
    } else {
      api.reload('20bdf2bd', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=20bdf2bd&scoped=true&", function () {
      api.rerender('20bdf2bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B72eL5gGpKkp/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports